module.exports = __webpack_public_path__ + "img/square-o.90c392f8.svg";